import { Table } from 'semantic-ui-react';
import { LEVEL_NAME, fmtWhen } from '../approvals.js';

/* Every approval recorded for this report, newest first: who, what and when. */
export default function ApprovalHistory({ rows }) {
  if (!rows.length) return null;
  const sorted = [...rows].sort((a, b) => b.approved_at.localeCompare(a.approved_at));
  return (
    <section className="block" aria-labelledby="hist-heading">
      <h3 id="hist-heading" className="ui small header blockhead">Approval history for this report</h3>
      <Table celled compact unstackable>
        <caption className="visually-hidden">Approvals recorded for this report</caption>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell scope="col">Period</Table.HeaderCell>
            <Table.HeaderCell scope="col">Approval</Table.HeaderCell>
            <Table.HeaderCell scope="col">Person</Table.HeaderCell>
            <Table.HeaderCell scope="col">Date and time</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {sorted.map((a) => (
            <Table.Row key={a.approval_id}>
              <Table.Cell>{a.period_type === 'year' ? `Annual ${a.period_label}` : a.period_type === 'quarter' ? `${a.period_label} ${a.period_start.slice(0, 4)}` : `${a.period_label} ${a.period_start.slice(0, 4)}`}</Table.Cell>
              <Table.Cell>{LEVEL_NAME[a.approval_level]}</Table.Cell>
              <Table.Cell>{a.approved_by_name}</Table.Cell>
              <Table.Cell><time dateTime={a.approved_at}>{fmtWhen(a.approved_at)}</time></Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </section>
  );
}
